import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { CreditTile } from './CreditTile/CreditTile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UsageCreditsOverage = ({
  credits,
  isLoading
}) => /*#__PURE__*/_jsxs(CreditTile, {
  isLoading: isLoading,
  children: [/*#__PURE__*/_jsx(CreditTile.Count, {
    hasLowCredits: true,
    children: /*#__PURE__*/_jsx(FormattedNumber, {
      value: credits
    })
  }), /*#__PURE__*/_jsx(CreditTile.Label, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubSpotCredits.labelOverage"
    })
  })]
});